function TicketHandlerSvc($resource) {
  'ngInject';

  var tickets = []

  return {
    addTicket: addTicket,
    setTickets: setTickets,
    getTickets: getTickets,
    clearTickets: clearTickets
  }

  function addTicket(ticket) {
    tickets.push(ticket)
  }

  function setTickets(ticketsIn) {
    tickets = [] 
    ticketsIn.forEach(function (i, index) {
      tickets.push(i)
    });
  }

  function clearTickets() {
    tickets = []
  }

  function getTickets() {
    return tickets;
  }
};

export default {
  name: "TicketHandlerSvc",
  fn: TicketHandlerSvc
}